// Standard Construction Categories
export const STANDARD_CATEGORIES = [
  'General Conditions',
  'Site Work',
  'Concrete',
  'Masonry',
  'Metals',
  'Wood & Plastics',
  'Thermal & Moisture Protection',
  'Doors & Windows',
  'Finishes',
  'Specialties',
  'Equipment',
  'Furnishings',
  'Special Construction',
  'Conveying Systems',
  'Mechanical',
  'Electrical',
  'Plumbing',
  'HVAC',
  'Fire Protection',
  'Drywall',
  'Flooring',
  'Roofing',
  'Insulation',
  'Painting',
  'Landscaping',
  'MEP',
  'Site Prep',
];

// Mapping of common variations to standard categories
const CATEGORY_MAPPINGS = {
  'general': 'General Conditions',
  'general conditions': 'General Conditions',
  'general_conditions': 'General Conditions',
  'generalconditions': 'General Conditions',
  'site work': 'Site Work',
  'site_work': 'Site Work',
  'sitework': 'Site Work',
  'site prep': 'Site Work',
  'site_prep': 'Site Work',
  'siteprep': 'Site Work',
  'wood & plastics': 'Wood & Plastics',
  'wood plastics': 'Wood & Plastics',
  'wood_plastics': 'Wood & Plastics',
  'woodplastics': 'Wood & Plastics',
  'doors & windows': 'Doors & Windows',
  'doors windows': 'Doors & Windows',
  'doors_windows': 'Doors & Windows',
  'doorswindows': 'Doors & Windows',
  'thermal & moisture': 'Thermal & Moisture',
  'thermal & moisture protection': 'Thermal & Moisture Protection',
  'thermal moisture': 'Thermal & Moisture Protection',
  'thermal moisture protection': 'Thermal & Moisture Protection',
  'thermal_moisture': 'Thermal & Moisture Protection',
  'thermal_moisture_protection': 'Thermal & Moisture Protection',
  'thermalmoisture': 'Thermal & Moisture Protection',
  'mep': 'Mechanical',
  'finishes': 'Finishes',
  'finish': 'Finishes',
  'drywall': 'Drywall',
  'concrete': 'Concrete',
};

// Helper to normalize category names (for display consistency)
export const normalizeCategory = (category) => {
  if (!category) return 'Uncategorized';
  
  // Trim and remove extra spaces
  const cleaned = category.trim().replace(/\s+/g, ' ');
  
  // Convert to lowercase for comparison
  const lowerCase = cleaned.toLowerCase();
  
  // First check if there's a direct mapping (case-insensitive)
  if (CATEGORY_MAPPINGS[lowerCase]) {
    return CATEGORY_MAPPINGS[lowerCase];
  }
  
  // Convert common variations to standard format
  const normalized = cleaned
    .replace(/_/g, ' ')  // Replace underscores with spaces
    .replace(/\s+/g, ' ')  // Replace multiple spaces with single space
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))  // Capitalize each word
    .join(' ');
  
  // Check if the normalized version has a mapping
  const normalizedLower = normalized.toLowerCase();
  if (CATEGORY_MAPPINGS[normalizedLower]) {
    return CATEGORY_MAPPINGS[normalizedLower];
  }
  
  return normalized;
};

// Get unique custom categories from phases
export const getCustomCategories = (phases) => {
  const categories = new Set();
  phases.forEach(phase => {
    if (phase.category) {
      const normalized = normalizeCategory(phase.category);
      if (!STANDARD_CATEGORIES.includes(normalized)) {
        categories.add(normalized);
      }
    }
  });
  return Array.from(categories).sort();
};

// Get all available categories (standard + custom)
export const getAllCategories = (phases) => {
  const customCats = getCustomCategories(phases);
  return [...STANDARD_CATEGORIES, ...customCats];
};
